import { TranslocoService } from '@ngneat/transloco';
import { SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';
import { StatusTagConfiguration } from '@platform-frontend/ui-tools';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../marketplace-transloco-scope';
import { BOOKED_STATUS_TAG_CONFIGURATION } from './booked-status-tag-configuration';

export const SUBSCRIPTION_BOOKING_STATUS_TAG_CONFIGURATIONS: (
  translocoService: TranslocoService,
  canceledTooltipDate?: string,
  tooltipClass?: string
) => StatusTagConfiguration<SubscriptionBookingStatus>[] = (translocoService: TranslocoService, expiringTooltipDate?: string, tooltipClass?: string) => [
  BOOKED_STATUS_TAG_CONFIGURATION(translocoService),
  {
    status: 'SUBSCRIBED',
    class: 'success',
    icon: 'tick-circle-duo',
    tagText: translocoService.selectTranslate('asset.bookingStatusTags.subscription.subscribedStatus', {}, MARKETPLACE_TRANSLOCO_SCOPE)
  },
  {
    status: 'EXPIRING',
    class: 'warning',
    icon: 'time-duo',
    tagText: translocoService.selectTranslate('asset.bookingStatusTags.subscription.expiringStatus', {}, MARKETPLACE_TRANSLOCO_SCOPE),
    tooltipText: expiringTooltipDate
      ? translocoService.selectTranslate('asset.bookingStatusTags.subscription.expiringTooltip', { expiringTooltipDate }, MARKETPLACE_TRANSLOCO_SCOPE)
      : undefined,
    tooltipClass: tooltipClass
  }
];
